import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BellStateFalseNotiTrueIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BellStateFalseNotiTrueIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.8394 22.0962C9.67774 22.0962 7.91895 20.3374 7.91895 18.1753C7.91895 17.7612 8.25489 17.4253 8.66895 17.4253H15.0098C15.4238 17.4253 15.7598 17.7612 15.7598 18.1753C15.7598 20.3374 14.001 22.0962 11.8394 22.0962ZM9.5376 18.9253C9.85401 19.894 10.7666 20.5962 11.8394 20.5962C12.9121 20.5962 13.8247 19.894 14.1411 18.9253H9.5376Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.1023 9.60645C20.0395 9.60645 21.6099 8.03606 21.6099 6.09888C21.6099 4.1617 20.0395 2.59131 18.1023 2.59131C16.1651 2.59131 14.5947 4.1617 14.5947 6.09888C14.5947 8.03606 16.1651 9.60645 18.1023 9.60645Z"
        fill="#FC3B26"
      />
      <path
        d="M20.0361 10.5286C19.5837 10.7266 19.0908 10.8375 18.5788 10.8883L19.7305 16.3306C19.7847 16.5874 19.7213 16.8511 19.5562 17.0552C19.3907 17.2583 19.1456 17.3755 18.8834 17.3755H5.11677C4.85407 17.3755 4.60896 17.2583 4.44343 17.0552C4.27839 16.8511 4.21491 16.5874 4.2696 16.3306L5.92048 8.52978C6.52448 5.67431 9.08161 3.60107 12.0001 3.60107C12.6311 3.60107 13.239 3.71484 13.8201 3.8955C14.0648 3.42138 14.3725 2.9873 14.7533 2.6206C13.8912 2.28735 12.9625 2.10107 12.0001 2.10107C8.37703 2.10107 5.20272 4.67431 4.45272 8.21923L2.80184 16.02C2.6534 16.7212 2.82723 17.4419 3.2784 17.9995C3.72957 18.5561 4.39949 18.8755 5.11678 18.8755H18.8834C19.6002 18.8755 20.2701 18.5561 20.7213 17.9995C21.1724 17.4429 21.3463 16.7212 21.1983 16.02L20.0361 10.5286Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BellStateFalseNotiTrueIcon;
